module.exports = __webpack_public_path__ + "img/comemorando.9f2e3cd6.png";